require ('./userNotificationsContent.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { formatText } = require('core/i18n').i18n;

class UserNotificationsContent extends React.Component{
    getNotificationLink() {
        const { link, linkText } = this.props;
        let notificationLink;

        if (link && linkText) {
            notificationLink = (
                <OKLink
                    modifier="emphasize"
                    target="_blank"
                    to={link}
                >
                    {linkText}
                </OKLink>
            );
        }

        return notificationLink;
    }

    buildActionButtons(){
        const { actions, referenceId, onHandleActionClick } = this.props;
        let actionButtons;
        if(actions && actions.length) {
            actionButtons = actions.map((action, key) => {
                action.referenceId = referenceId;
                action.path = action.addReferenceIdInPath ? action.path + referenceId : action.path;
                return (
                    <span key={key} className={"user-notifications-content__link"}>
                        <OKButton
                            modifier="link-emphasize"
                            onClick={(evt) => onHandleActionClick(evt, action)}
                        >
                            {action.value}
                        </OKButton>
                    </span>
                );
            });
        }
        return actionButtons;
    }

    render(){
        const {
            date,
            isNotificationClickable,
            message,
            messageLinkAction,
            onHandleActionClick,
            referenceId,
            className
        } = this.props;
        const formattedDate = `${date} ${formatText('userNotificationsSection-formattedTime')}`;
        const notificationLink = this.getNotificationLink();
        const actionButtons = this.buildActionButtons();
        const customClass = `row no-gutter user-notifications-content ${className}`;
        messageLinkAction.referenceId = referenceId;
        return (
            <div className={customClass}>
                <div className="user-notifications-content__messages" onClick={(evt) => {isNotificationClickable && onHandleActionClick(evt, messageLinkAction)}}>
                    {message}
                </div>
                <div className="col-xs-12 user-notifications-content__date">
                    {formattedDate}
                </div>
                <div className="col-xs-8-cc-6">
                    {notificationLink}
                    <div>
                        {actionButtons}
                    </div>
                </div>
            </div>
        );
    }
}

UserNotificationsContent.propTypes = {
    actions: PropTypes.array,
    className: PropTypes.string,
    date: PropTypes.string.isRequired,
    isNotificationClickable: PropTypes.bool,
    link: PropTypes.string,
    linkText: PropTypes.string,
    message: PropTypes.string.isRequired,
    messageLinkAction: PropTypes.object,
    onHandleActionClick: PropTypes.func,
    referenceId: PropTypes.string
};

module.exports = UserNotificationsContent;
